const b2bPopup = () => {
    var $body = $("body");
    var $modal = $("#b2bModal");
    
    if (!$modal.length) {
        return;
    }

    var $confirmButton = $("#b2bConfirm");
    var $declineButton = $("#b2bDecline");

    $body.removeClass("b2b-modal-closed").addClass("b2b-modal-open");

    $confirmButton.off("click.b2bConfirm").on("click.b2bConfirm", function (e) {
        e.preventDefault();

        $body.addClass("b2b-modal-closed");

        setTimeout(function () {
            $modal.hide();
            $body.removeClass("b2b-modal-open");
        }, 300);
    });

    $declineButton.off("click.b2bDecline").on("click.b2bDecline", function (e) {
        e.preventDefault();

        const url = $(this).attr('data-redirect-url')

        window.location.replace(url);
    })
};

export default b2bPopup;
